import React, { useEffect, useState } from "react";

import { FaSearch } from "react-icons/fa";
import Menu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import Loading from "../../../../components/Loading";
import { producaov2 as api } from "../../../../services/apis";
import {
  Card,
  Cards,
  ContainerLoading,
  Loader,
  PeriodContainer,
  SearchBarBox,
  SearchButton
} from "./styles";

  const AnalyticData = () => {
  const [inscricao, setInscricao] = useState(0);
  const [contagemEmAndamento, setContagemEmAndamento] = useState(0);  
  const [contagemExpirados, setContagemExpirados] = useState(0);
  const [contagemConcluidos, setContagemConcluidos] = useState(0);
  const [contagemInscricaoGratuita, setContagemInscricaoGratuita] = useState(0);
  const [contagemRegistrosCertificados, setContagemRegistrosCertificados] = useState(0);
  const [alunos, setAlunos] = useState(0);
  const [cupons, setCupons] = useState(0);
  const [CursosCriados, setCursosCriados] = useState(0);
  const [contasExcluidas, setContasExcluidas] = useState(0);
  const [dataInicio, setDataInicio] = useState("2022-01-01");
  const [dataFim, setDataFim] = useState(`${new Date().toJSON().slice(0,10)}`);
  const [loading, setLoading] = useState(false);
  const [load, setLoad] = useState(false);
  
  const getAnalyticData = async () => {
      setLoad(false);
      const response = await api
      .get(`admin/absolute-date?initial_date=${dataInicio}&final_date=${dataFim}`);

      setInscricao(response.data.inscricaoPaga);
      setContagemEmAndamento(response.data.cursosEmAndamento)
      setContagemExpirados(response.data.cursosExpirados);
      setContagemConcluidos(response.data.cursosEmConcluidos);
      setContagemInscricaoGratuita(response.data.inscricaoGratuita);
      setContagemRegistrosCertificados(response.data.numCertificados);
      setAlunos(response.data.numTotalAlunos);
      setCupons(response.data.cuponsCriados);
      setCursosCriados(response.data.cursosCriados);
      setContasExcluidas(response.data.contasExcluidas);
      setLoad(true);
      setLoading(true);
    };

  useEffect(() => {
    getAnalyticData();
  },[])

  if(loading){
    return (
      <>
        <Menu />
        <Cards>
          {
            !load ? (
              <ContainerLoading>
                <Loader size="small" color="#c6c6c6" />
              </ContainerLoading>
            ): (
              <>
                 <Card > Alunos <p>{alunos}</p> </Card>
          <Card > Vendas <p>{inscricao}</p> </Card>
          <Card > Inscrição Gratuita<p>{contagemInscricaoGratuita}</p> </Card>
          <Card > Cursos Em andamento<p>{contagemEmAndamento}</p> </Card>
          <Card> Cursos Concluidos <p>{contagemConcluidos}</p></Card>
          <Card> Certificados Gerados <p>{contagemRegistrosCertificados}</p></Card>
          <Card > Cursos Criados <p>{CursosCriados}</p> </Card>
          <Card > Cupons Gerados<p>{cupons}</p> </Card>
          <Card > Contas Excluidas<p>{contasExcluidas}</p> </Card>
          <Card> Cursos Expirado <p>{contagemExpirados}</p></Card>
              </>
            )
          }
         
        </Cards>
        <SearchBarBox>
          
          <PeriodContainer>
          <fieldset>
            <label>Data Inicio</label>
            <input
              type="date"
              onChange={(e) => setDataInicio(e.target.value)}
              value={dataInicio}
            />
          </fieldset>
          <fieldset>
            <label>Data Fim</label>
            <input
            type="date"
              onChange={(e) => setDataFim(e.target.value)}
              value={dataFim}
            />
          </fieldset>
            </PeriodContainer>
            <SearchButton onClick={getAnalyticData}>
            <FaSearch />
          </SearchButton>
        </SearchBarBox>
      </>
    );
  }

  return <Loading
  msg=
    "Buscando dados..." 
  
/>
};

export default AnalyticData;